var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-wrapper"},[_c('VueApexCharts',{attrs:{"height":"300","chart":_vm.apexCharts,"options":{ ..._vm.options, chart: { ..._vm.options.chart, ..._vm.chart }, xaxis: { ..._vm.options.xaxis, categories: _vm.categories } },"series":_vm.series,"l":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }